import React, { Component } from 'react';
import cookie from 'react-cookies';
import '../login/Login.css';
import './../home/Home.css';
import logoimg from '../../assets/logo.svg';
import '../../assets/sprite-icon.svg';
import { UserService } from '../../_services';
import { history, SVCMessage } from '../../_helpers';
import { toastr } from 'react-redux-toastr';
import favicon from '../../assets/favicon.ico';
import { Router } from 'react-router';
import PearsonDrawer from '../../components/pearson-drawer/pearson-drawer';

//pearson ui
import { Button, TextInput, RadioCheckGroup, Icon, Footer } from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import configJson from '../../_helpers/config.json';
const basePath= configJson["CommonConstants"]["Base_path"]
export default class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cpEmailId: JSON.parse(localStorage.getItem("user")).email_id,
            cpEmailIdInputState: 'disabled',
            cpOldPassword: '',
            cpOldPasswordInputState: 'default',
            cpNewPassword: '',
            cpNewPasswordInputState: 'default',
            cpConfirmPassword: '',
            cpConfirmPasswordInputState: 'default',
            cpNewPasswordMessage: 'New password is required'
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeConfirmPassword = this.handleChangeConfirmPassword.bind(this);
        this.handleChangeNewPassword = this.handleChangeNewPassword.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.checkNullOrEmpty = this.checkNullOrEmpty.bind(this);
        this.clearChangePasswordInputs = this.clearChangePasswordInputs.bind(this);
        this.logout = this.logout.bind(this);
    };

    componentDidMount() {

    };

    handleChange(e) {
        const { id, value } = e.target;
        if (value.length <= 50) {
            this.setState({ [id]: value });
        }
    };

    handleChangeConfirmPassword(e) {
        const { id, value } = e.target;
        this.setState({ cpConfirmPassword: value });
        if (value != this.state.cpNewPassword) {
            this.setState({ cpConfirmPasswordInputState: 'error' });
            return false;
        }

        this.setState({ cpConfirmPasswordInputState: 'default' });
    };

    handleChangeNewPassword(e) {
        const { id, value } = e.target;
        this.setState({ cpNewPassword: value });
        if (value.length == 0) {
            this.setState({ cpNewPasswordInputState: 'error' });
            this.setState({ cpNewPasswordMessage: 'New password is required.' });
            return false;
        }
        let passwordRegex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (!passwordRegex.test(value)) {
            this.setState({ cpNewPasswordInputState: 'error' });
            this.setState({ cpNewPasswordMessage: 'Password should contain atleast one number, one special character, one upper case, one lower case and at least 8 characters.' });
            return false;
        }

        this.setState({ cpNewPasswordInputState: 'default', cpNewPasswordMessage: 'New password is required' });
    };

    componentDidMount() {

    };

    checkNullOrEmpty(input) {
        if (input === '' || input == undefined || input === null) {
            return true;
        }
        return false;
    }

    changePassword(e) {
        e.preventDefault();
        if (this.checkNullOrEmpty(this.state.cpEmailId)) {
            this.setState({ cpEmailIdInputState: "error" });
            return false;
        }
        this.setState({ cpEmailIdInputState: "disabled" });

        if (this.checkNullOrEmpty(this.state.cpOldPassword)) {
            this.setState({ cpOldPasswordInputState: "error" });
            return false;
        }
        this.setState({ cpOldPasswordInputState: "default" });

        if (this.checkNullOrEmpty(this.state.cpNewPassword)) {
            this.setState({ cpNewPasswordInputState: "error" });
            return false;
        }
        this.setState({ cpNewPasswordInputState: "default" });

        if (this.checkNullOrEmpty(this.state.cpConfirmPassword) || (this.state.cpNewPassword != this.state.cpConfirmPassword)) {
            this.setState({ cpConfirmPasswordInputState: "error" });
            return false;
        }
        this.setState({ cpConfirmPasswordInputState: "default" });

        let params = {
            userName: this.state.cpEmailId,
            oldPassword: this.state.cpOldPassword,
            newPassword: this.state.cpNewPassword
        };

        UserService.changePassword(params).then((data) => {
            if (data.isSuccess) {
                toastr.success(SVCMessage[data.message]);
                // this.clearChangePasswordInputs();
                this.logout();
            } else {
                toastr.error(SVCMessage[data.message]);
            }
        });
    }

    clearChangePasswordInputs() {
        // this.setState({
        //     cpEmailId: '',
        //     cpEmailIdInputState: 'default',
        //     cpOldPassword: '',
        //     cpOldPasswordInputState: 'default',
        //     cpNewPassword: '',
        //     cpNewPasswordInputState: 'default',
        //     cpConfirmPassword: '',
        //     cpConfirmPasswordInputState: 'default'
        // });

        console.log(this.props);

        this.props.history.goBack();
    }

    logout() {
        UserService.logout().then(res => {
            history.push(basePath+'/logout');
        },
            error => {
                toastr.error('Login', error);
            }
        );
    }

    render() {
        const FooterLink = [{ text: 'Terms of Use', href: 'https://register.pearsoncmg.com/reg/include/license2.jsp' }, { text: ' Privacy Policy', href: 'https://register.pearsoncmg.com/w3c/privacy.htm' }];
        return (

            <div className="login-section">
                {/* Header Section Start  */}
                <header className="pe-fixed-header">
                    <div className="pe-header-lt">
                        <div className="logo">
                            <div className='pe_logo_name'>
                                <img src={favicon} alt="Pearson Favicon" width="40" className='pe_mobile_logo' />
                                <img src={logoimg} alt="Pearson Logo" width="130" className='pe_desktop_logo' />
                            </div>
                            <div className="pe_logo_desc"> SEARCHABLE <br></br> VIDEO COLLECTION </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                    <div className="pe-header-rt">
                        <div className="pe-v-header-rt-sec">
                            <ul>
                                <li >
                                    <div className="pe-help-icon">
                                        <PearsonDrawer />
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="clear"></div>
                </header>

                {/* Change Password Form Area Start  */}
                <div className="pe-v-login-form">
                    <h1 className="title">Welcome to the Pearson Searchable Video Collection</h1>
                    <form className="form-signin" id="pe-change-password-form">
                        <h2 className="title">Change Password</h2>
                        <div className="pe-v-login-body">
                            <div className="pe-form--group">
                                <TextInput id="cpEmailId" inputState={this.state.cpEmailIdInputState}
                                    changeHandler={(e) => {
                                        let cpEmailId = e.target.value;
                                        if (cpEmailId.length <= 100) {
                                            this.setState({ cpEmailId });
                                        }
                                    }} value={this.state.cpEmailId} labelText="Email" placeholder="Email" infoMessage="" errorMessage="Email is required" />
                            </div>
                            <div className="pe-form--group">
                                <TextInput password={true} id="cpOldPassword" inputState={this.state.cpOldPasswordInputState} changeHandler={this.handleChange} labelText="Old Password" placeholder="Enter Old Password" infoMessage="" errorMessage="Old password is required" />
                            </div>
                            <div className="pe-form--group">
                                <TextInput password={true} id="cpNewPassword" inputState={this.state.cpNewPasswordInputState} changeHandler={this.handleChangeNewPassword} labelText="New Password" placeholder="Enter New Password" infoMessage="" errorMessage={this.state.cpNewPasswordMessage} />
                            </div>
                            <div className="pe-form--group">
                                <TextInput password={true} id="cpConfirmPassword" inputState={this.state.cpConfirmPasswordInputState} changeHandler={this.handleChangeConfirmPassword} labelText="Confirm Password" placeholder="Enter Confirm Password" infoMessage="" errorMessage="Password does not match the confirm password" />
                            </div>
                            <div className="clearfix"></div>
                            <div className="pe-submit-action">
                                <Button btnType="primary" btnSize="xlarge" onClick={this.changePassword}>Submit</Button>
                            </div>
                        </div>
                        <div className="pe-v-login-footer">
                            <div className="pe-forgot-password">
                                <Button type="button" btnIcon onClick={() => {
                                    this.clearChangePasswordInputs();
                                }}>Go Back </Button>
                            </div>
                        </div>
                    </form>
                </div>
                {/* Change Password Form Area End  */}

                {/* Footer Area Start */}
                <Footer links={FooterLink} anchorTarget="blank" />
                {/* Footer Area End */}

            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/change-password/change-password.js